export default [
  {
    path: '/keys/',
    name: 'keys',
    title: 'keys',
    component: () => import('../views/KeysView.vue'),
    redirect: { name: 'liberacaoAviso' },
    children: [
      {
        path: '/keys/serial',
        name: 'serial',
        component: () => import('../views/SerialFormView.vue'),
        meta: {
          layout: 'EmptyLayout',
        },
      },
      {
        path: '/keys/liberacaoAviso',
        name: 'liberacaoAviso',
        component: () => import('../views/LiberacaoAvisoView.vue'),
        meta: {
          layout: 'EmptyLayout',
        },
      },
      {
        path: '/keys/pagamentoLicenca',
        name: 'pagamentoLicenca',
        component: () => import('../views/PagamentoLicencaView.vue'),
        meta: {
          layout: 'EmptyLayout',
        },
      },
      {
        path: '/keys/pagamentoLicencaPix',
        name: 'pagamentoLicencaPix',
        component: () => import('../views/PagamentoLicencaPixView.vue'),
        meta: {
          layout: 'EmptyLayout',
        },
      },
      {
        path: '/keys/pagamentoLicencaBoleto',
        name: 'pagamentoLicencaBoleto',
        component: () => import('../views/PagamentoLicencaBoletoView.vue'),
        meta: {
          layout: 'EmptyLayout',
        },
      },
    ],
  },
];
